import type { ExpenseListItem } from "@apps/dashboard/lib/home-expense-types";

/** Importe que cuenta en agregados: real si existe, si no la previsión. */
export function expenseEffectiveMinor(e: Pick<ExpenseListItem, "amountMinor" | "actualAmountMinor">): number {
  return e.actualAmountMinor != null ? e.actualAmountMinor : e.amountMinor;
}
